import React from "react";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { CURRENCY_SYMBOL } from "../../constants/currency-symbol.c";
import { formatAmount } from "../../constants/currency-codes.c";

export default function ProductView({
  amountLabel,
  currency,
  productList,
}: {
  amountLabel: any;
  currency: any;
  productList: any;
}) {
  const { t } = useTranslation();
  const totalPrice = (Quantity: number, Price: number) => {
    return Quantity * Price;
  };
  return (
    <>
      {productList.length > 0 && (
        <Grid className="product-list-wrap" item xs={6}>
          <div className="product-lists">
            <div className="product-total-amount">
              <h4>
                {t("merchant.Order_Overview")}
                {/* <span>
                {CURRENCY_SYMBOL[currency]}
                {entity === ENTITY.JP ? amountLabel : amountLabel.toFixed(2)}
                 <strong> {currency}</strong>
              </span> */}
              </h4>
            </div>
            <div className="products-listings">
              <div className="mobile-view-wrap">
                {productList?.map((paymentconfig: any, index: any) => (
                  <React.Fragment key={index}>
                    <div
                      className={
                        paymentconfig?.RequireImage
                          ? "product-box"
                          : "product-box no-image"
                      }
                    >
                      { paymentconfig?.RequireImage && (
                        <div className="product-image">
                          <img
                            draggable="false"
                            className="pro-image"
                            src={paymentconfig?.Image || "/products/default.jpg"}
                            alt="Product"
                          />
                        </div>
                      )}

                      <div className="product-details">
                        {
                          paymentconfig?.Name === "Appointment Charges" ? <h5 className="product-name">{t("merchant.Appointment_Charges")}</h5>
                                                                       : <h5 className="product-name">{paymentconfig?.Name}</h5>
                        }

                      { paymentconfig?.RequireImage ? (
                          <h6 className="product-quantity">
                            <strong className="payment-quantitys">
                              {paymentconfig?.RequireImage}
                              {paymentconfig?.Quantity}
                            </strong>
                            <span> X </span>
                            <span className="multiply-price">
                              {" "}
                              {CURRENCY_SYMBOL[currency]}
                              {paymentconfig?.Price}
                            </span>
                          </h6>
                        ) : null}
                        <h6 className="product-price p-total-price" style={{ top: paymentconfig?.RequireImage ? "" : "0px" }}>
                          {CURRENCY_SYMBOL[currency]}
                          {formatAmount(currency, totalPrice(
                            paymentconfig.Quantity,
                            paymentconfig.Price
                          ))}
                        </h6>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>

              <div
                className="total-price"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h4>{t("ProductPopup.Total_Price")}</h4>
                <h5>
                  <span>
                    {CURRENCY_SYMBOL[currency]}
                    {formatAmount(currency, amountLabel || 0)}
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </Grid>
      )}
    </>
  );
}
